import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../get-action-types";
import { INIT, ERROR, LOADING, OK } from "../../constants";
import { Status } from "../../types";
import { Action } from "redux";

function getStatusReducer<T extends string>(types: T[]) {
  if (types.length === 1) {
    let type = types[0]; //we don't have types, we got only one action type
    return function statusReducer(state: Status = INIT, action: Action<T>): Status {
      switch (action.type) {
        case getRequestActionType(type):
          return LOADING;
        case getSuccessActionType(type):
          return OK;
        case getFailureActionType(type):
          return ERROR;
        default:
          return state;
      }
    };
  } else {
    let requestActions = types.map((type) => getRequestActionType(type));
    let successActions = types.map((type) => getSuccessActionType(type));
    let failureActions = types.map((type) => getFailureActionType(type));
    return function statusReducer(
      state: Status = INIT,
      action: Action<T | typeof requestActions[number] | typeof successActions[number] | typeof failureActions[number]>
    ): Status {
      if (requestActions.some((i) => i === action.type)) {
        return LOADING;
      } else if (successActions.some((i) => i === action.type)) {
        return OK;
      } else if (failureActions.some((i) => i === action.type)) {
        return ERROR;
      } else {
        return state;
      }
    };
  }
}

export default getStatusReducer;
